import { FormControl, InputBase, styled, TextField } from "@mui/material";


export const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(3),
    },
    "& .MuiFormHelperText-root": {
        color: "#e5453b !important",
    },
    "& input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #c4d8ff !important",
        fontSize: 16,
        padding: "10px 26px 10px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            borderRadius: 4,
            borderColor: "#80bdff",
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
    },
}));

export const FormSelectControl = styled(FormControl)(() => ({
    margin: 0,
    width: "30%",
}));

export const FormTextControl = styled(FormControl)(() => ({
    marginLeft: "1%",
    width: "69%",
}));


export const CssTextField = styled(TextField)({
    "& .MuiFormHelperText-root": {
        color: "#e5453b !important",
    },
    "& label": {
        fontSize: 14,
        color: "#2c2f44",
        fontFamily: "SF Pro Text Light",
        textTransform: "inherit",

    },

    "& label.MuiInputLabel-shrink": {
        fontSize: "0.9rem",
    },
    "& label.Mui-focused": {
        color: "#638dff",
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#c4d8ff",
        },
        "&:hover fieldset": {
            borderColor: "#92afff",
        },
        "&.Mui-disabled": {
            cursor: "pointer",
            backgroundColor: "#f4f7fb !important",
            "& fieldset": {
                borderColor: "#c4d8ff",
            },
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#638dff !important",
            "WebkitTextFillColor": "#638dff !important",

        },
        "&.Mui-error": {
            "& fieldset": {
                borderColor: "#f2a29d !important",
            },
        },
        "&.Mui-focused fieldset": {
            borderColor: "#638dff",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            color: "#44485a",
            "WebkitTextFillColor": "#44485a",
        },
        fontSize: 14,
        borderRadius: 6,
        fontFamily: "SF Pro Text Regular",
        color: "#2c2f44",
        backgroundColor: "white",
    },
});
